import Header from './Header';
import CarouselSwiper from './CarouselSwiper';
import Newsletter from './Newsletter';
import CarouselTest from './CarouselTest';

const components = {
  Header,
  CarouselSwiper,
  Newsletter,
  CarouselTest
}


export default components;
